import { z } from "zod";
import { SortDir } from "@yalana/contracts";

// Defaults are NOT set via Zod `.default()` so TanStack Router does not
// serialize them into the URL. Clean URLs keep `waitForURL` globs working
// and avoid noise like `?page=1&pageSize=10` on first visit.
export const paginationSearch = z.object({
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).optional(),
});

export type PaginationSearch = z.infer<typeof paginationSearch>;

export const PAGINATION_DEFAULTS = { page: 1, pageSize: 10 } as const;

// Extended search schema for list pages with text search and server-side sort.
export const listSearch = paginationSearch.extend({
  q: z.string().optional(),
  sort: z.string().optional(),
  dir: SortDir.optional(),
});

export type ListSearch = z.infer<typeof listSearch>;
